import './tracer'
import './index.css'
// Do not delete this line, its used for importing styles
import '!style-loader!css-loader?-url!@energytoolbase/components/dist/index.css'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))
